export const styles = {
  label: 'rounded-sm w-[100px] h-5',
  value: 'rounded-sm w-[160px] h-7 mt-1',
};

export const wrapperSkeletonBlocks = new Array(4).fill('');
export const areaInfoSkeletonBlocks = new Array(3).fill('');
